// Mock data for Budlee AI Landing Page

export const heroData = {
  taglineLine1: "Helps students understand lessons",
  taglineLine2: "and discover curiosity early.",
  primaryCTA: "Get Started for Students",
  secondaryCTA: "For Schools & Partners",
  heroImage: "/images/hero.png"
};

export const curriculumData = {
  title: "Aligned with",
  highlight: "CBSE & State Syllabuses",
  subtitle: "Curriculum",
  subject: "Science (Physics, Chemistry, Biology)",
  boards: [
    { id: "cbse", name: "CBSE", tag: "Central Board" },
    { id: "kerala", name: "Kerala", tag: "State Syllabus" },
    { id: "tamilnadu", name: "Tamil Nadu", tag: "State Board" },
    { id: "karnataka", name: "Karnataka", tag: "State Board" },
    { id: "andhra", name: "Andhra Pradesh", tag: "State Board" },
    { id: "telangana", name: "Telangana", tag: "State Board" },
    { id: "maharashtra", name: "Maharashtra", tag: "State Board" },
    { id: "gujarat", name: "Gujarat", tag: "State Board" }
  ],
  grades: ["Grade 6", "Grade 7", "Grade 8", "Grade 9", "Grade 10"],
  classes: [
    { class: "Grade 6", subject: "Science (Physics, Chemistry, Biology)" },
    { class: "Grade 7", subject: "Science (Physics, Chemistry, Biology)" },
    { class: "Grade 8", subject: "Science (Physics, Chemistry, Biology)" },
    { class: "Grade 9", subject: "Science (Physics, Chemistry, Biology)" },
    { class: "Grade 10", subject: "Science (Physics, Chemistry, Biology)" }
  ]
};

export const navigationData = {
  logo: "budlee",
  logoSuffix: "AI",
  navItems: [
    { label: "For Schools & Partners", href: "#", hasDropdown: true }
  ]
};
